module.exports = __webpack_public_path__ + "img/characterAnime17.ce148499.png";